import { get, set } from 'lodash';
export function migrateBodyPaddings(message) {
    var bodyGlobalCssKey = 'data.composerData.styles.css.so-global-body';
    var bodyGlobalCss = get(message, bodyGlobalCssKey);
    // Inside region builders/renderers we need to know
    // if current campaign was created using v1 or v2 engine.
    // Currently the logo region should behave as in v1.
    var isCreatedUsingV1Engine = [
        bodyGlobalCss.paddingLeft,
        bodyGlobalCss.paddingRight,
    ].some(function (_) { return !!_; });
    if (isCreatedUsingV1Engine) {
        set(message, 'data.composerData.styles.v1', true);
    }
    var leftSpacing = bodyGlobalCss.paddingLeft || '0px';
    var rightSpacing = bodyGlobalCss.paddingRight || '0px';
    var regionGlobalCssKey = 'data.composerData.styles.css.so-global-region';
    var regionGlobalCss = get(message, regionGlobalCssKey);
    regionGlobalCss.marginLeft = regionGlobalCss.marginLeft || leftSpacing;
    regionGlobalCss.marginRight = regionGlobalCss.marginRight || rightSpacing;
    bodyGlobalCss.paddingLeft = '';
    bodyGlobalCss.paddingRight = '';
    return message;
}
//# sourceMappingURL=migrate-body-paddings.js.map